import dayjs from "dayjs";

import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import CardContainer from "./cardContainer";

const IntroCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  const lastUpdated = briefing.lastUpdated
    ? dayjs(briefing.lastUpdated).format("D MMM YYYY")
    : null;

  return (
    <CardContainer
      innerClassNames="flex flex-col items-center justify-center md:justify-between gap-[10px] md:flex-row md:gap-[16px]"
      id={id}
    >
      <div className="grid gap-[10px] md:gap-[16px]">
        <h1 className="text-[32px] font-[700] leading-tight md:text-[48px]">
          {briefing.name}
        </h1>
        <p className="text-[20px] leading-tight md:text-[28px]">
          {briefing.description}
        </p>
        {lastUpdated && (
          <p className="text-[14px] uppercase">Last updated: {lastUpdated}</p>
        )}
      </div>
    </CardContainer>
  );
};

export default IntroCard;
